import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useVenue } from '../../hooks/useVenue'
import { DetailEntityPage } from '../DetailEntityPage/DetailEntityPage'
import { Badge } from '../../components/Badge/Badge'
import { formatDate } from '../../helpers/formatDate'
import { getVenueStatusBadgeColor } from '../../helpers/getVenueStatusBadgeColor'
import type { DetailFieldDef } from '../../types'

const venueNote = (
  <span>
    <strong>Note</strong>: Used to manage static venues and placeholders (e.g.
    AV inventory system profiles) to enable tenant config.
  </span>
)

export function VenueDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { venue, isLoading, error } = useVenue(id ?? '')

  const fields: DetailFieldDef[] = venue
    ? [
        {
          label: 'ID',
          value: <span className="font-monospace small">{venue.id}</span>,
        },
        {
          label: 'Sys Venue ID',
          value: (
            <span className="font-monospace small">{venue.sysVenueId}</span>
          ),
        },
        {
          label: 'Name',
          value: <span className="fw-medium">{venue.name}</span>,
        },
        {
          label: 'Slug',
          value: <span className="fw-medium">{venue.venueSlug}</span>,
        },
        {
          label: 'Status',
          value: (
            <Badge color={getVenueStatusBadgeColor(venue.status)}>
              {venue.status}
            </Badge>
          ),
        },
        { label: 'Type', value: <Badge color="grey">{venue.type}</Badge> },
        {
          label: 'ISP Type',
          value: <Badge color="grey">{venue.inventorySystemType}</Badge>,
        },
        {
          label: 'Timezone',
          value: <Badge color="blue">{venue.timezone}</Badge>,
        },
        { label: 'Latitude', value: venue.latitude },
        { label: 'Longitude', value: venue.longitude },
        { label: 'Created', value: formatDate(venue.createdAt) },
        { label: 'Updated', value: formatDate(venue.updatedAt) },
      ]
    : []

  return (
    <DetailEntityPage
      title={venue ? `Venue - ${venue.name}` : 'Venue'}
      loadingLabel="venue"
      note={venueNote}
      fields={fields}
      isLoading={isLoading}
      error={error}
      actions={
        id ? (
          <div className="d-flex gap-2">
            <Link to={`/venues/${id}/edit`} className="btn btn-primary btn-sm">
              Edit
            </Link>
            <Link
              to={`/venues/${id}/delete`}
              className="btn btn-outline-danger btn-sm"
            >
              Delete
            </Link>
          </div>
        ) : undefined
      }
    />
  )
}
